<button [appButton]="'ghost'" class="header-button">{{ text }}</button>
